import { ScheduleRuleContext } from '@/rule/models/ScheduleRuleContext';
import { ScheduleMsg } from '@/rule/models/ScheduleMsg';

export enum ScheduleRuleType {
  Event = 1,
  TimeField = 2,
  Periodic = 3,
}

export interface ScheduleRuleInterface {
  id: number;
  ruleName?: string;
  ruleType?: number;
  ruleContext?: ScheduleRuleContext;
  scheduleMsg?: ScheduleMsg;
  gmtCreate?: string;
  gmtModified?: string;
  status: number;
}

export class ScheduleRule implements ScheduleRuleInterface {
  public id: number;
  public ruleName?: string;
  public ruleType?: number;
  public ruleContext?: ScheduleRuleContext | any;
  public scheduleMsg?: ScheduleMsg;
  public gmtCreate?: string;
  public gmtModified?: string;
  public status: number;

  constructor() {
    this.id = 0;
    this.status = 0;
    this.scheduleMsg = null
  }

  public fromApi(rule: ScheduleRule) {
    this.id = rule.id;
    this.ruleName = rule.ruleName;
    this.ruleType = rule.ruleType;
    this.ruleContext = rule.ruleContext;
    this.scheduleMsg = rule.scheduleMsg;
    this.gmtCreate = rule.gmtCreate;
    this.gmtModified = rule.gmtModified;
    this.status = rule.status;
  }
}

export default new ScheduleRule();
